<template>
  <div
    class="team-slot d-flex align-center"
    :class="[`slot-${teamSlot}`, {
      'is-empty': !game.playersByTeam(team.id)[teamSlot - 1],
      'is-winner': wonAmount && (showWinnings || game.canShowWinners)
    }]"
  >
    <div v-if="wonAmount" class="won-amount">
      <span class="d-flex align-center text-h6 green500--text">
        <fai :icon="['fas', 'plus']" class="mr-2 text-body-2" />
        <scrap :amount="wonAmount" />
      </span>
    </div>

    <BattleListingPlayer
      :game="game"
      :player="game.playersByTeam(team.id)[teamSlot - 1]"
      :color="team.color"
      class="mr-2 mb-2"
      no-tooltip
      :size="48"
    />

    <div class="bg-ui-panel--dark slot-info flex-grow-1 pa-3 of-hidden pos-relative">
      <v-overlay absolute :value="loading">
        <v-progress-circular indeterminate size="24" />
      </v-overlay>

      <Username
        v-if="game.playersByTeam(team.id)[teamSlot - 1]"
        :user="game.playersByTeam(team.id)[teamSlot - 1]"
      />
      <div v-else-if="isCreator && game.banditsAvailable(config.bot)">
        <div v-if="game.banditsAvailable(config.bot)">
          <fai :icon="['fad', 'robot']" class="blue200--text mr-1" />
          Call a bandit
        </div>
      </div>
      <div v-else-if="!canJoin || isCreator && !game.banditsAvailable(config.bot)" class="d-flex align-center">
        Waiting for player

        <v-spacer />

        <v-tooltip
          v-if="isCreator"
          top content-class="rounded-0" color="primary600"
        >
          <template #activator="{ on }">
            <div class="bot-disabled-icon align-self-center primary400--text ml-1" v-on="on">
              <fai :icon="['fad', 'robot']" />
            </div>
          </template>
          <span v-text="'Bandits cannot join this game'" />
        </v-tooltip>
      </div>
      <div v-else class="font-weight-bold d-flex align-center">
        <span v-if="game.isCommunism">Join group</span>
        <span v-else-if="team.slots > 1">Join team</span>
        <span v-else>Join battle</span>

        <v-spacer />

        <div class="game-price pos-relative d-flex align-center">
          <div
            v-if="game.config.funding"
            :class="{'is-free': !game.joinPrice}"
            class="text-caption grey200--text non-funded-price"
          >
            {{ game.price | toScrap }}
          </div>
          <scrap v-if="game.joinPrice" class="text-body-2" :amount="game.joinPrice" />
          <span v-else class="green400--text font-weight-bold mr-1">Free</span>
          <v-tooltip v-if="game.config.funding" top color="green600" content-class="rounded-0">
            <template #activator="{ on }">
              <fai :icon="['fad', 'badge-percent']" class="green400--text ml-1 mb-1" v-on="on" />
            </template>
            <span>Creator is paying {{ game.config.funding }}%</span>
          </v-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BattleListingPlayer from '@/views/games/CaseBattles/components/BattleListingPlayer'

export default {
  components: {
    BattleListingPlayer,
  },
  props: {
    game: {
      type: Object,
      required: true,
    },
    team: {
      type: Object,
      required: true,
    },
    teamSlot: {
      type: Number,
      required: true,
    },
    wonAmount: {
      type: Number,
      default: null,
    },
    config: {
      type: Object,
      required: true,
    },
    showWinnings: Boolean,
    isCreator: Boolean,
    canJoin: Boolean,
    loading: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.team-slot {
  position: relative;
  width: 100%;
  max-width: 275px;
  transition: transform 0.3s ease;

  ::v-deep .battle-player {
    transform: rotate(0);
  }

  &.is-empty {
    cursor: pointer;

    &:hover {
      transform: translateY(-3px);
    }
  }

  &.is-winner {
    animation: win-float 2s ease-in-out infinite;

    .won-amount > span {
      opacity: 1;
    }

    &.slot-2 {
      animation-delay: -500ms;
    }

    &.slot-3 {
      animation-delay: -1200ms;
    }

    &.slot-4 {
      animation-delay: -250ms;
    }
  }
}

.non-funded-price {
  position: absolute;
  text-decoration: line-through;
  transform: translate(65%, -75%);

  &.is-free {
    transform: translate(0, -80%);
  }
}

.won-amount {
  position: absolute;
  z-index: 4;
  top: -8px;
  left: 50%;
  transform: translate(-50%, -100%);
  pointer-events: none;

  > span {
    opacity: 0;
  }
}

.bot-disabled-icon {
  display: inline-block;
  position: relative;

  &::after {
    position: absolute;
    z-index: 2;
    top: 50%;
    left: -10%;
    width: 120%;
    height: 0.2em;
    background: primary(800);
    content: ' ';
    transform: translateY(-50%) rotate(45deg);
  }
}

.bg-ui-panel--light {
  background-color: rgba(#6e6b65, 0.55);
}

.bg-ui-panel--dark {
  background-color: rgba(#6e6b65, 0.85);
}

@keyframes win-float {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-12px);
  }

  100% {
    transform: translateY(0);
  }
}

</style>
